import React from "react";
import ConfigProvider, { ThemeConfig } from "antd/es/config-provider";
import themeInternal from "antd/es/theme";

const theme: ThemeConfig = {
    algorithm: themeInternal.darkAlgorithm,
    token: {
        colorPrimary: "#FFD700",          // gold primary
        colorSuccess: "#52c41a",
        colorWarning: "#faad14",
        colorError: "#ff4d4f",
        colorInfo: "#005BBB",              // Liberland blue dark mode variant
        colorText: "#f0f0f0",              // light text for dark mode
        colorBgBase: "#121212",            // dark background
        fontFamily: "Inter, sans-serif",
        borderRadius: 8,
        fontSize: 16,
    },
    components: {
        Button: {
            colorPrimary: "#FFD700",
            colorPrimaryHover: "#e6c200",
            colorPrimaryActive: "#ccae00",
            colorPrimaryText: "#00205B",  // darker blue text on gold button
            colorText: "#f0f0f0",
            borderRadius: 6,
        },
        Layout: {
            headerBg: "rgba(18, 18, 18, 1)",
            headerColor: "#f0f0f0",
            footerBg: "rgba(18, 18, 18, 0.85)",
            siderBg: "#121212",
            bodyBg: "#121212",
        },
        Menu: {
            colorItemText: "#f0f0f0",
            colorItemBg: "#FFD700",
        },
        Input: {
            colorBgContainer: "#1f1f1f",
            colorText: "#f0f0f0",
            colorTextPlaceholder: "#999999",
        },
        Card: {
            colorBgContainer: "#1f1f1f",
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(255, 215, 0, 0.2)",
        },
        Table: {
            headerBg: "#332a00",
            headerColor: "#f0f0f0",
            rowHoverBg: "#443b00",
            borderColor: "#FFD700",
        },
        Modal: {
            headerBg: "#1f1f1f",
            contentBg: "#1f1f1f",
        },
        Drawer: {
            colorBgElevated: "#1f1f1f",
            colorText: "#f0f0f0",
        },
        Tabs: {
            colorPrimary: "#FFD700",
            itemColor: "#f0f0f0",
            itemSelectedColor: "#00205B",
            itemHoverColor: "#333333",
            inkBarColor: "#FFD700",
        },
        Dropdown: {
            colorBgElevated: "#1f1f1f",
        },
        Tooltip: {
            colorText: "#FFD700",
        },
        Alert: {
            colorInfoBg: "#003366",
            colorSuccessBg: "#143d08",
            colorWarningBg: "#665200",
            colorErrorBg: "#660000",
        },
        Tag: {
            colorText: "#f0f0f0",
            colorBorder: "#FFD700",
        },
        Progress: {
            colorBgContainer: "#1f1f1f",
            colorSuccess: "#FFD700",
        },
        Badge: {
            colorText: "#f0f0f0",
        },
        Avatar: {
            colorText: "#f0f0f0",
        },
        Collapse: {
            colorBgContainer: "#1f1f1f",
            colorBorder: "#1f1f1f",
            colorText: "#f0f0f0",
        },
        Popconfirm: {
            colorBgElevated: "#1f1f1f",
            colorText: "#f0f0f0",
            colorPrimary: "#FFD700",
        },
        Steps: {
            colorPrimary: "#1f1f1f",
            colorText: "#f0f0f0",
        },
        Timeline: {
            colorPrimary: "#FFD700",
            colorText: "#f0f0f0",
        },
        Calendar: {
            colorPrimary: "#FFD700",
            colorText: "#f0f0f0",
            colorBgContainer: "#1f1f1f",
        },
        DatePicker: {
            colorPrimary: "#FFD700",
            colorBgContainer: "#1f1f1f",
            colorText: "#f0f0f0",
        },
        Slider: {
            colorPrimary: "#FFD700",
            colorText: "#f0f0f0",
        },
        Rate: {
            colorFill: "#FFD700",
        },
        Spin: {
            colorPrimary: "#FFD700",
        },
        Pagination: {
            colorPrimary: "#FFD700",
            colorText: "#f0f0f0",
            colorBgContainer: "#1f1f1f",
        },
    },
};

export const Provider: React.FunctionComponent<React.PropsWithChildren> = (props) => {
    return (
        <ConfigProvider theme={theme}>
            {props.children}
        </ConfigProvider>
    );
};
